const CACHE_NAME = 'ilori-audio-chapters';

/**
 * Sweeps old chapters sequentially, leaving the current and next untouched.
 */
export async function cleanupAudioCache(currentChapterId: string, nextChapterId?: string) {
    try {
        if (!('caches' in window)) return;
        const cache = await caches.open(CACHE_NAME);
        const keys = await cache.keys();
        for (const key of keys) {
            if (!key.url.includes(`/audio/${currentChapterId}`) && (!nextChapterId || !key.url.includes(`/audio/${nextChapterId}`))) {
                await cache.delete(key);
            }
        }
    } catch (e) {
        console.warn("Audio cache cleanup failed:", e);
    }
}

/**
 * Returns a Blob object URL if the chapter is currently stored in Cache API.
 */
export async function getCachedAudioUrl(chapterId: string): Promise<string | null> {
    try {
        if (!('caches' in window)) return null;
        const cache = await caches.open(CACHE_NAME);
        const cachedRes = await cache.match(`/audio/${chapterId}`);
        if (cachedRes) {
            const blob = await cachedRes.blob();
            return URL.createObjectURL(blob);
        }
    } catch (e) {
        console.warn("Cache read error:", e);
    }
    return null;
}

/**
 * Fetch and put the remote TTS Audio URL into the HTML5 Cache API cleanly.
 */
export async function cacheAudioBackground(chapterId: string, url: string) {
    try {
        if (!('caches' in window)) return;
        const cache = await caches.open(CACHE_NAME);
        const res = await fetch(url);
        if (res.ok) {
            await cache.put(`/audio/${chapterId}`, res.clone());
        }
    } catch (e) {
        console.warn("Background cache fetch failed:", e);
    }
}

/**
 * Eager background prefetch request hitting Next.js TTS route for caching explicitly.
 */
export async function prefetchNextChapterAudio(storySlug: string, nextChapterId: string) {
    try {
        const res = await fetch(`/api/tts?storySlug=${encodeURIComponent(storySlug)}&chapterId=${encodeURIComponent(nextChapterId)}&prefetch=true`);
        const prefetchData = await res.json();
        
        if (prefetchData.url) {
            await cacheAudioBackground(nextChapterId, prefetchData.url);
        }
    } catch (err) {
        console.error("Prefetch error:", err);
    }
}
